import { TextNode } from "@easy-email-pro-core/typings";
import { get, isString, set } from "lodash";
import React from "react";

export const ContentLeaf = ({
  node,
  extraStyle,
}: {
  node: TextNode;
  extraStyle?: React.CSSProperties;
}) => {
  let children: React.ReactNode = node.text;
  const style: React.CSSProperties = {
    ...extraStyle,
  };

  if (!children) return null;

  const leaf = node;
  const keys = Object.keys(leaf);

  keys
    .filter((item) => item !== "text")
    .forEach((key) => {
      switch (key) {
        case "bold":
          children = <strong>{children}</strong>;
          break;
        case "italic":
          children = <em>{children}</em>;
          break;
        case "underline":
          children = <u>{children}</u>;
          break;
        case "strikethrough":
          children = <del>{children}</del>;
          break;

        case "color":
          style.color = leaf.color;
          break;
        case "bgColor":
          style.backgroundColor = leaf.bgColor;
          break;
        case "fontSize":
          style.fontSize = leaf.fontSize;
          break;
        case "fontFamily":
          style.fontFamily = leaf.fontFamily;
          break;
        case "link":
          if (leaf.link) {
            children = (
              <a
                style={style}
                href={leaf.link.href}
                target={leaf.link.blank ? "_blank" : undefined}
              >
                {children}
              </a>
            );
          }
          break;
        default:
          set(style, key, get(leaf, key));
      }
    });

  if (isString(children) && Object.keys(style).length === 0) {
    return <>{children}</>;
  }

  return <span style={style}>{children}</span>;
};
